import { Component, OnInit, ElementRef, Input, HostListener, ViewChild } from '@angular/core';
import { ReadMoreOptions } from './read-more.interface';

@Component({
  selector: 'minni-read-more,[readMore]',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
})
export class ReadMoreComponent implements OnInit {
  @Input('readMore') readMoreLineLimit = '2';
  @Input() readMoreOptions: ReadMoreOptions = {
    readLessText: 'show less',
    readMoreText: 'show more'
  }
  @ViewChild('showMore', { static: true }) showMore!: HTMLElement;
  isShowMoreEnable = false;
  backgroundColor = "inherit";

  constructor(public eleRef: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.setInitialStyle();
  }

  @HostListener("click", ["$event"]) onClick(event: Event) {
    if (!this.isContentClamped() && event.target === this.eleRef.nativeElement) {
      this.handleShowMoreEnable(false)
    }
  }

  isContentClamped() {
    return this.eleRef.nativeElement.scrollHeight > this.eleRef.nativeElement.clientHeight
  }

  handleShowMoreEnable(action: boolean) {
    this.isShowMoreEnable = action;
    this.eleRef.nativeElement.classList.toggle('minni-line-clamp-none')
  }

  setInitialStyle() {
    this.backgroundColor = this.getBackgroundColor();
    this.eleRef.nativeElement.style.webkitLineClamp = this.readMoreLineLimit;
  }

  getBackgroundColor() {
    let currentElement = this.eleRef?.nativeElement?.parentElement
    while (!currentElement?.style.backgroundColor && currentElement != document.querySelector("body")) {
      if (currentElement?.parentElement) {
        currentElement = currentElement.parentElement
      }
    }
    return currentElement?.style.backgroundColor || '#fff';
  }
}
